/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_List_Column_Last_Active_AtInputs */

const en_admin_user_list_column_last_active_at = /** @type {(inputs: Admin_User_List_Column_Last_Active_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last used`)
};

const de_admin_user_list_column_last_active_at = /** @type {(inputs: Admin_User_List_Column_Last_Active_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuletzt genutzt`)
};

/**
* | output |
* | --- |
* | "Last used" |
*
* @param {Admin_User_List_Column_Last_Active_AtInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_list_column_last_active_at = /** @type {((inputs?: Admin_User_List_Column_Last_Active_AtInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_List_Column_Last_Active_AtInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_list_column_last_active_at(inputs)
	return en_admin_user_list_column_last_active_at(inputs)
});